import { getRealm } from "@solana/spl-governance";
import { useConnection } from "@solana/wallet-adapter-react";
import { useQuery } from "@tanstack/react-query";

import { MNDE_REALM_PUBKEY } from "solana/ids";

/**
 * For simplicity, it always fetches MNDE realm
 */
export const useRealmByPubkeyQuery = () => {
  const { connection } = useConnection();
  const realmPk = MNDE_REALM_PUBKEY;

  const enabled = realmPk !== undefined;
  return useQuery({
    queryKey: enabled ? ["realms", realmPk.toString()] : undefined,
    queryFn: async () => {
      if (!enabled) throw new Error();
      return getRealm(connection, realmPk);
    },
    cacheTime: 1 * 24 * 60 * 60 * 1000,
    staleTime: 12 * 60 * 60 * 1000,
    enabled,
  });
};
